module.exports = __webpack_public_path__ + "static/img/4023_phase_function_Paper_Points.c5e9f15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4023_phase_function_Paper_Points.png
// module id = Dksq
// module chunks = 0